import { connect } from 'react-redux';
import { pipe } from 'fp-ts/function';
import { createStructuredSelector } from 'reselect';
import { ApplicationState } from '@mews-commander/types';
import { AppClockServiceProps, DateTime, withAppClockService } from '@mews/framework';
import { getSelectedServiceId } from '@mews-commander/legacy-entities/src/ducks/serviceSelect';
import { startOccupancyStatisticsPoller, resetOccupancyStatistics } from '../../actions/occupancyStatistics';
import { getOccupancyPollerStart, getOccupancyPollerEnd } from '../../selectors/occupancyStatistics';
import { OccupancyReport } from './OccupancyReport';

interface StateProps {
    start: DateTime;
    end: DateTime;
    selectedServiceId: string;
}

interface DispatchProps {
    startPoller: (...args: any[]) => void;
    resetWidget: () => void;
}

export type OccupancyReportWrapperProps = StateProps & DispatchProps;

export const OccupancyReportWrapper = pipe(
    OccupancyReport,
    connect<StateProps, DispatchProps, AppClockServiceProps, ApplicationState>(
        createStructuredSelector({
            start: getOccupancyPollerStart,
            end: getOccupancyPollerEnd,
            selectedServiceId: getSelectedServiceId,
        }),
        {
            startPoller: startOccupancyStatisticsPoller,
            resetWidget: resetOccupancyStatistics,
        }
    ),
    withAppClockService
);
